<script>
import options from './StafetAddDeltager.options'
export default options
</script>

<template>
  <article class="kb-stafet-flow-add-participants kb-optimizely-forms">
    <div class="kb-stafet-step__input-wrapper">
      <FormInputTextField
        :modelValue="numberOfAdults.toString()"
        v-model="numberOfAdults"
        fieldName="numberOfAdults"
        :label="labels.registerDeltagereSelectAdultNumberLabel"
        :placeholder="labels.registerDeltagereSelectAdultNumberLabel"
        v-on:input="setNumberOfAdults($event.target.value)"
        type="number"
        :isValidationError="
          totalNumberOfParticipants === 0 && displayInputError
        "
        :errorMessageLabel="labels.registerDeltagereSelectAdultNumberErrorMessage"
      />

      <FormInputTextField
        :modelValue="numberOfChildren.toString()"
        v-model="numberOfChildren"
        :localValue="numberOfChildren"
        fieldName="numberOfChildren"
        :label="labels.registerDeltagereSelectChildNumberLabel"
        :placeholder="labels.registerDeltagereSelectChildNumberLabel"
        v-on:input="setNumberOfChildren($event.target.value)"
        type="number"
        :isValidationError="
          totalNumberOfParticipants === 0 && displayInputError
        "
        :errorMessageLabel="labels.registerDeltagereSelectChildNumberErrorMessage"
        />

      <template v-for="(adult, index) in adults">
        <div class="kb-stafet-step__input-wrapper">
          <h3>{{ labels.registerDeltagereAdultTitle }} {{ index + 1 }}</h3>

          <FormInputTextField
            :modelValue="adult.name"
            v-model="adult.name"
            fieldName="adultName"
            :label="labels.registerDeltagereNameLabel"
            :placeholder="labels.registerDeltagereNameLabel"
            :isRequired="true"
            :isValidationError="
              !nonEmptyStringValidator(adult.name) && displayInputError
            "
            :errorMessageLabel="labels.registerDeltagereNameErrorMessage"
          />

          <FormInputTextField
            v-if="!excludeMail"
            :modelValue="adult.email"
            v-model="adult.email"
            fieldName="adultEmail"
            :label="labels.registerDeltagereEmailLabel"
            :placeholder="labels.registerDeltagereEmailLabel"
            :isRequired="true"
            :isValidationError="
              !emailValidator(adult.email) && displayInputError
            "
            :errorMessageLabel="labels.registerDeltagereEmailErrorMessage"
          />
        </div>
      </template>

      <template v-for="(child, index) in children">
        <div class="kb-stafet-step__input-wrapper">
          <h3>{{ labels.registerDeltagereChildTitle }} {{ index + 1 }}</h3>

          <FormInputTextField
            :modelValue="child.name"
            v-model="child.name"
            fieldName="childrenName"
            :label="labels.registerDeltagereNameLabel"
            :placeholder="labels.registerDeltagereNameLabel"
            :isRequired="true"
            :isValidationError="
              !nonEmptyStringValidator(child.name) && displayInputError
            "
            :errorMessageLabel="labels.registerDeltagereNameErrorMessage"
          />

          <FormInputTextField
            v-if="!excludeMail"
            :modelValue="child.email"
            v-model="child.email"
            fieldName="childrenEmail"
            :label="labels.registerDeltagereEmailLabel"
            :placeholder="labels.registerDeltagereEmailLabel"
            :isRequired="true"
            :isValidationError="
              !emailValidator(child.email) && displayInputError
            "
            :errorMessageLabel="labels.registerDeltagereEmailErrorMessage"
          />
        </div>
      </template>
    </div>
  </article>
</template>
